import { Subject } from "rxjs";
import { switchMap } from "rxjs/operators";
// import { sendChatMessage } from "./chatbotService";
import store from "../../../../../app/store";
import { _post } from "../../../../../api/chatbotApiClient";

const _orgClientId = () => {
  const state = store.getState();
  return state?.orgReducer?.selectedFI?.orgClientId;
};

export const userMessage$ = new Subject();

export const botResponse$ = userMessage$.pipe(
  switchMap((message) => _post(`${_orgClientId()}/chat`, message)),
);
// export const botResponse$ = userMessage$.pipe(
//   switchMap((message) => sendChatMessage(message)),
// );
